import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/auth-provider";
import { ProtectedRoute } from "@/auth/protected-route";
import { Layout } from "@/components/shell/layout";
import { LoginRoute } from "@/routes/login";
import { DashboardRoute } from "@/routes/dashboard";
import { ThisWeekRoute, NextWeekRoute } from "@/routes/this-week";
import { OrdersRoute } from "@/routes/orders-list";
import { OrderDetailRoute } from "@/routes/orders/detail";
import { InvoicesRoute } from "@/routes/invoices-list";
import { BalanceRoute } from "@/routes/balance";
import { AccountRoute } from "@/routes/account";
import { MapRoute } from "@/routes/map";
import { ShopRoute } from "@/routes/shop";
import { InvoiceDetailRoute, NotFoundRoute } from "@/routes/placeholders";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 min — viz plán §6.10
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardRoute />} />
              <Route path="this-week" element={<ThisWeekRoute />} />
              <Route path="next-week" element={<NextWeekRoute />} />
              <Route path="orders" element={<OrdersRoute />} />
              <Route path="orders/:orderNr" element={<OrderDetailRoute />} />
              <Route path="invoices" element={<InvoicesRoute />} />
              <Route path="invoices/:nr" element={<InvoiceDetailRoute />} />
              <Route path="balance" element={<BalanceRoute />} />
              <Route path="map" element={<MapRoute />} />
              <Route path="shop" element={<ShopRoute />} />
              <Route path="account" element={<AccountRoute />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="404" element={<NotFoundRoute />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </QueryClientProvider>
  );
}
